<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-query`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.6 2h28.8c1.924 0 3.496 1.537 3.595 3.472l.005.195v16.5h-3.6v-16.5H9.6v36.666H24V46H9.6c-1.924 0-3.496-1.537-3.595-3.472L6 42.333V5.667c0-1.96 1.51-3.56 3.409-3.662L9.6 2zm22.935 25.707l3.88 3.879 3.878-3.879a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.415l-3.878 3.878 3.878 3.879a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-3.879-3.878-3.879 3.878a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l3.879-3.879-3.879-3.879a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0zM31.797 13V9c-6.545 0-11.92 5.173-12.172 11.713l-.277 6.21-.001.019a6.982 6.982 0 01-7.265 6.688l-.165 3.997c6.06.25 11.176-4.46 11.426-10.52l.002-.031.277-6.209A8.181 8.181 0 0131.797 13z"/></svg>
</template>
<script>

export default {
  name: 'IconQuery',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
